import {
  Bot,
  Calendar,
  CalendarDays,
  Compass,
  Crown,
  Database,
  Flag,
  Gift,
  Globe,
  GraduationCap,
  Heart,
  HelpCircle,
  ImageIcon,
  ImagePlus,
  Mail,
  MessageCircle,
  MessageCircleQuestion,
  MessageSquare,
  Music,
  Paintbrush,
  Pentagon,
  Phone,
  Search,
  Send,
  Server,
  ShieldAlert,
  ShieldOff,
  Ticket,
  Trophy,
  User,
  UserPlus,
  Users,
  Video,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { SmileUpsideDown } from "./icons";

const iconMap: Record<string, LucideIcon> = {
  bot: Bot,
  calendar: Calendar,
  "calendar-days": CalendarDays,
  compass: Compass,
  crown: Crown,
  database: Database,
  flag: Flag,
  gift: Gift,
  globe: Globe,
  "graduation-cap": GraduationCap,
  heart: Heart,
  "help-circle": HelpCircle,
  image: ImageIcon,
  "image-plus": ImagePlus,
  mail: Mail,
  "message-circle": MessageCircle,
  "message-circle-question": MessageCircleQuestion,
  "message-square": MessageSquare,
  music: Music,
  paintbrush: Paintbrush,
  pentagon: Pentagon,
  phone: Phone,
  search: Search,
  send: Send,
  server: Server,
  "shield-alert": ShieldAlert,
  "shield-off": ShieldOff,
  "smile-upside-down": SmileUpsideDown,
  ticket: Ticket,
  trophy: Trophy,
  user: User,
  "user-plus": UserPlus,
  users: Users,
  video: Video,
};

export type EmptyStateIcon = keyof typeof iconMap;

interface EmptyStateProps {
  icon: EmptyStateIcon;
  title?: string;
  message?: string | string[];
  className?: string;
}

export function EmptyState({ icon, title, message, className }: EmptyStateProps) {
  const Icon = iconMap[icon]!;
  const messages = message == null ? [] : Array.isArray(message) ? message : [message];
  return (
    <div className={`flex flex-col items-center text-center pt-6 ${className ?? ""}`}>
      <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-3">
        <Icon className="w-6 h-6 text-muted-foreground" />
      </div>
      {title && <p className="text-foreground font-medium mb-1 text-balance">{title}</p>}
      {messages.map((msg, i) => (
        <p key={i} className="text-muted-foreground text-base max-w-xs text-balance">
          {msg}
        </p>
      ))}
    </div>
  );
}
